export enum StationStatus {
  OFFLINE = 'OFFLINE',
  RECHARGING = 'RECHARGING',
  NO_CHARGERS_AVAILABLE = 'NO_CHARGERS_AVAILABLE',
  ALREADY_RENTED = 'ALREADY_RENTED',
  PRE_AUTH_FAILED = 'PRE_AUTH_FAILED',
  ISSUE_EJECTING = 'ISSUE_EJECTING',
}

export enum ConnectionState {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  NO_INTERNET = 'NO_INTERNET',
}

export enum StationBatteryAvailability {
  RENTABLE = 'RENTABLE',
  ALL_BATTERIES_CHARGING = 'ALL_BATTERIES_CHARGING',
  NO_BATTERIES_AVAILABLE = 'NO_BATTERIES_AVAILABLE',
}

export type StationCampusCard = {
  enabled: boolean;
  institutionId?: string;
};

export type StationOnlineStatus = {
  online: boolean;
  connectionState?: ConnectionState;
  availability?: StationBatteryAvailability;
};

export type StationInformation = StationOnlineStatus & {
  campusCard: StationCampusCard;
};
